module.exports = __webpack_public_path__ + "img/dinghuo.f8e46bfb.png";